function UserTransactionValue() {
    "use strict";
    this.__type = 'UserTransactionValue:www.veritracks.com';
    this.Id = -1;
    //this.Version = 0;


    this.DataTypeId = -1;
    this.LogDateIsGMTFlag = true;
    this.LogDateName = '';
    this.LogDateValue = new Date();
    this.LogNumberName = '';
    this.LogNumberValue = -1;
    this.LogStringName = '';
    this.TransactionId = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = UserTransactionValue;
}